import { metricsAxios } from 'api/apiBase/axios';
import { mapError } from 'api/apiBase/mapError';
import { mapResponse } from 'api/apiBase/mapResponse';

import { MarketPrecision } from '../types';

import { GetMarketPrecisionRequest } from './api.types';

/**
 * Retrieves precision and limits for a trading symbol on a specific exchange.
 *
 * @param req - Request parameters including symbol, exchange name, and optional abort signal.
 * @returns A promise resolving to market precision data or a mapped error.
 * @see https://api-metrics-dev.111pg.info/swagger/index.html#/market/get_api_v1_market_precision
 */
export async function getMarketPrecision(req: GetMarketPrecisionRequest) {
  const { symbol, cex, signal } = req;

  try {
    const response = await metricsAxios.get<MarketPrecision>('/api/v1/market/precision', {
      params: { symbol, cex },
      signal,
    });

    return mapResponse<MarketPrecision>({ data: response.data });
  } catch (error) {
    return mapError<MarketPrecision>({ error });
  }
}
